import { render, staticRenderFns } from "./OttoPaySettings.vue?vue&type=template&id=51d7146a"
import script from "./OttoPaySettings.vue?vue&type=script&lang=ts"
export * from "./OttoPaySettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports